import {MockupDataModel} from "../../../../qr-copy-message/mockup-data.model";

export const INVALID_FORM_MESSAGE = MockupDataModel.error("Not all required fields are filled in.");

export const EDIT_SUCCESS_MESSAGE = MockupDataModel.success("The product was updated successfully.");
export const EDIT_PARTIAL_SUCCESS_MESSAGE = MockupDataModel.info("The product was updated, but some images could not be saved.");
export const EDIT_ERROR_MESSAGE = MockupDataModel.error("An error occurred while updating the product. Please verify the information and try again.");

export const CREATE_SUCCESS_MESSAGE = MockupDataModel.success("The product was added successfully.");
export const CREATE_ERROR_MESSAGE = MockupDataModel.error("An error occurred while saving the product. Please verify the information and try again.");

export const LOAD_PRODUCT_DATA_ERROR_MESSAGE = MockupDataModel.error("Unable to load product details. Please try again later.");

export const MAX_PRODUCT_GALLERY_LENGTH: number = 4;
export const MAX_SELECTED_COLORS: number = 3;
